














































import { Glide, GlideSlide } from "vue-glide-js";
import * as moment from "moment";
import axios from "axios";
import { staticContent } from "../../localisation/detect-lang";
import {
  Vue,
  servicesURL,
  headers,
  photosUrlEnum,
  mixpanelEvents,
  DynamicCardTypes,
} from "../../constants/constants";
import {
  updatePhotosURL,
  isRTL,
  pushMixpanelEvent,
  isLoggedInUser,
} from "../../helpers";

import { getRemoteConfigAsBoolean } from "../../firebase";
import restaurantCard from "./dyn-offers-card.vue";

export default Vue.component("dynamic-section", {
  components: {
    restaurantCard,
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  props: ["data", "order"],
  data() {
    return {
      items: [],
      flashOfferEndTime: null,
      intervalId: null,
      active: 0,
      isRTL,
      showArrows: true,
      itemsPerView: 4,
      staticContent,
      options: {
        direction: isRTL ? "rtl" : "ltr",
        bound: true,
        rewind: false,
        type: "slider",
        perView: 4,
        startAt: 0,
        gap: 0,
        breakpoints: {
          1024: {
            perView: 3,
            gap: 15,
          },
          992: {
            perView: 2,
            gap: 15,
          },
          800: {
            perView: 1,
            gap: 15,
          },
        },
      },
    };
  },

  mounted() {
    this.getItems();
  },

  computed: {
    profile() {
      return this.$store.getters.getProfileData;
    },
    isImpressionTrackEnabled() {
      return (
        getRemoteConfigAsBoolean("Enable_Impression_Track") && isLoggedInUser()
      );
    },
    isNextArrowDisabled() {
      if (!this.showArrows) {
        return true;
      }
      return isRTL
        ? this.active === 0
        : this.items.length - this.itemsPerView - this.active <= 0;
    },
    isPrevArrowDisabled() {
      if (!this.showArrows) {
        return true;
      }
      return isRTL
        ? this.items.length - this.itemsPerView - this.active <= 0
        : this.active === 0;
    },
    isOffersType() {
      return this.data.viewType === DynamicCardTypes.Offers;
    },
    isFlashOffersType() {
      const { viewType } = this.data;
      return viewType === DynamicCardTypes.FlashOffers;
    },
    shouldViewOffers() {
      return this.isFlashOffersType || this.isOffersType;
    },
    remainingTime() {
      return (
        this.flashOfferEndTime &&
        this.flashOfferEndTime.utc().format("HH:mm:ss")
      );
    },
  },
  methods: {
    resLink(restaurant) {
      return this.$root.URLBuilder.restaurantURL(
        restaurant.name,
        restaurant.shortCode,
        this.$root.userCityName ? this.$root.userCityName : "cairo",
        "",
        isRTL ? "AR" : "EN"
      );
    },
    updatePhotosURL(url, version, ext = photosUrlEnum.ext.JPG) {
      return updatePhotosURL(url, version, ext);
    },
    getItems() {
      axios({
        method: "GET",
        url: servicesURL.dynamicSection(this.data.be_params),
        headers: headers,
        params: {
          zone: this.$root.user.zoneUUID,
          area: this.$root.user.areaUUID,
          lon: this.$root.long,
          lat: this.$root.lat,
        },
      })
        .then((res) => {
          const restaurants = res.data.data;
          if (this.isFlashOffersType && res.data.flashOfferEndTime) {
            this.flashOfferEndTime = this.getTimeDifference(
              res.data.flashOfferEndTime
            );
            this.startCountdown();
          }
          const mappedRestaurants = restaurants.map((restaurant) => {
            return this.getMappedRestaurantObject(restaurant.data);
          });

          if (this.shouldViewOffers) {
            this.items = mappedRestaurants.filter(
              (restaurant) => !!restaurant.offer || !!restaurant.hybridOffer
            );
          } else {
            this.items = mappedRestaurants;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMappedRestaurantObject(restaurantData) {
      let offerText = null;
      let hybridOffer = null;
      let offerType = "";
      let photoUrl = restaurantData.item.data.photoUrl;
      if (this.shouldViewOffers && restaurantData.hybridOffer) {
        hybridOffer = { ...restaurantData.hybridOffer };
        photoUrl = restaurantData.hybridOffer.photoUrl;
        offerType = restaurantData.hybridOffer.offerType;
      } else if (this.shouldViewOffers && restaurantData.offer) {
        offerText = restaurantData.offer.promo
          ? restaurantData.offer.promo.text
          : restaurantData.offer.discount.text;
        offerType = restaurantData.offer.promo
          ? restaurantData.offer.promo.promoType
          : "";
      }
      return {
        targetLink: this.resLink(restaurantData),
        offer: offerText,
        hybridOffer,
        title: restaurantData.item.data.name,
        cuisines: restaurantData.cuisinesName || [],
        edt: restaurantData.estimatedDeliveryTime,
        rating: restaurantData.rating,
        imgLink: this.updatePhotosURL(photoUrl, photosUrlEnum.version.normal),
        name: restaurantData.name,
        logo: this.updatePhotosURL(
          restaurantData.logo,
          photosUrlEnum.version.thumbnail
        ),
        offerType,
      };
    },
    visibilityChanged(isVisible, _entry, restaurant, restaurantIndex) {
      if (isVisible) {
        const {
          uuid,
          data: {
            email,
            profile: { name },
          },
        } = this.profile;

        const userProps = { userName: name, userId: uuid, email };
        const restaurantProps = {
          hyperlink: window.location.origin + restaurant.targetLink,
          imageUrl: restaurant.imgLink,
          position: restaurantIndex,
          sourceScreen: "Delivery",
          appSection: this.data.section_name,
          language: this.RTL ? "AR" : "EN",
        };
        const customProps = {
          Cuisines: restaurant.cuisines,
          EDT: restaurant.edt,
          "Section Title": this.RTL ? restaurant.titleAr : restaurant.titleEn,
          "Section Order": this.order + 1, // we add 1 Tasty offers section
          "Restaurant Name": restaurant.name,
          "Restaurant Rating": restaurant.rating,
        };
        pushMixpanelEvent(
          mixpanelEvents.impression.event,
          mixpanelEvents.impression.properties(
            userProps,
            restaurantProps,
            customProps
          )
        );
      }
    },
    onWindowResize() {
      if (window.innerWidth <= 1024) {
        this.showArrows = false;
      } else {
        this.showArrows = true;
      }
    },
    startCountdown() {
      this.intervalId = setInterval(() => {
        this.flashOfferEndTime = moment(
          this.flashOfferEndTime.subtract(1, "seconds")
        );
      }, 1000);
    },
    getTimeDifference(time) {
      const endTime = moment.utc(time);
      const now = moment();
      const diff = moment.duration(endTime.diff(now));
      const hours = diff.asHours();
      const minutes = diff.asMinutes() % 60;
      const seconds = diff.asSeconds() % 60;
      const stringDiff = `${hours}:${minutes}:${seconds}`;
      return moment(stringDiff, "HH:mm:ss");
    },
  },
  beforeDestroy() {
    this.intervalId && clearInterval(this.intervalId);
  },
});
